import React from 'react'
import PropTypes from 'prop-types'
import { ProgressBar } from 'react-bootstrap'

import styles from './LabeledProgressBar.module.scss'

/** Label + value header above a thin brand-colored progress bar. */
export default function LabeledProgressBar({
  label,
  valueLabel,
  now,
  max = 100,
  variant = 'purple',
}) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <span className={styles.label}>{label}</span>
        <span className={`${styles.value} ${styles[`${variant}Text`]}`}>
          {valueLabel}
        </span>
      </div>
      <ProgressBar
        now={now}
        max={max || 1}
        label={label}
        visuallyHidden
        className={`${styles.track} ${styles[variant]}`}
      />
    </div>
  )
}

LabeledProgressBar.propTypes = {
  label: PropTypes.node.isRequired,
  valueLabel: PropTypes.node,
  now: PropTypes.number.isRequired,
  max: PropTypes.number,
  variant: PropTypes.oneOf(['purple', 'pink']),
}
